import { Document, Packer, Paragraph, TextRun, Table, TableRow, TableCell, AlignmentType, WidthType, HeadingLevel, ImageRun } from "docx";
import { saveAs } from "file-saver";
import { Cookies } from "react-cookie";

// Helper for empty line
const blankLine = () => new Paragraph({ text: "" });
  const headerText = (t) => {return { text: t, heading: HeadingLevel.HEADING_3 }};
  const valueText = (t) => {return { text: t, size: 24, color: "333333" }};

  const tableHeader = (t) => new TableCell({ children:[ new Paragraph({ text:t, bold:true }) ], shading:{ fill:"F2D16B" }});
  const tableCell = (t) => new TableCell({ children:[ new Paragraph(String(t)) ] });

export async function generateQuoteDocx({ company, client, project, items, subtotal, hst, total, logoBase64 }) {
  
  const logoUrl = logoBase64;
  let logoImage = null;
  let bufferImg = null;

  try {
    const imgResp = await fetch(`/img/${company.id}.png`);
    const imgBlob = await imgResp.blob();
    bufferImg = await imgBlob.arrayBuffer();
    logoImage = new ImageRun({ data: bufferImg, transformation: { width: 132, height: 132 }, type : "png" });

  } catch (err) {
    console.error("Logo load failed", err);
  }
  const doc = new Document({
    sections: [
      {
        properties: {},
        children: [
        new Table({
          width: {
            size: 100,
            type: WidthType.PERCENTAGE,
          },
          rows:[


            new TableRow({ children:[
              
              new TableCell({ children:[
                new Paragraph({
                  children: [logoImage ],
                        alignment: AlignmentType.LEFT,
                      }),                
                  ]}),

              new TableCell({ children:[
                new Paragraph(headerText(company.name)),
                new Paragraph(valueText("A: " + company.address)),
                new Paragraph(valueText("E: " + company.email)),
                new Paragraph(valueText("T:" + company.phone)),
                new Paragraph(valueText("Prepared By:" + (new Cookies()).get('v-name'))),
              ]}),

              new TableCell({ children:[
                new Paragraph(valueText("Quote#: 25-Q-" + project.prj_code)),
                new Paragraph(valueText("Updated On: " + (new Date()).toISOString().split('T')[0])),
                new Paragraph(valueText("To: " + client.name)),
                new Paragraph(valueText("Jod Address: " + client.address)),
                new Paragraph(valueText(client.email)),
                new Paragraph(valueText(client.phone)),
              ]}),
            ] }),
          ]
        }),



          // ---------------------------
          //  PROJECT + QUOTE INFO
          // ---------------------------
          new Paragraph({
            text: `Project: ${project.prj_title}`,
            heading: HeadingLevel.HEADING_2,
            color: "D4AF37",
            spacing: { after: 100 },
          }),


          // ---------------------------
          // ITEMS TABLE
          // ---------------------------
          new Paragraph({
            text: "Quotation Items",
            heading: HeadingLevel.HEADING_2,
            color: "D4AF37",
            spacing: { after: 200 },
          }),

          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              // Header Row
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ text: "Description", bold: true, color: "FFFFFF" })],
                    shading: { fill: "000000" },
                  }),
                  new TableCell({
                    children: [new Paragraph({ text: "Qty", bold: true, color: "FFFFFF" })],
                    shading: { fill: "000000" },
                  }),
                  new TableCell({
                    children: [new Paragraph({ text: "Price", bold: true, color: "FFFFFF" })],
                    shading: { fill: "000000" },
                  }),
                  new TableCell({
                    children: [new Paragraph({ text: "Total", bold: true, color: "FFFFFF" })],
                    shading: { fill: "000000" },
                  }),
                ],
              }),

              // Item Rows
              ...items.map((item, index) =>
                new TableRow({
                  children: [
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new TextRun({ text: item.title, bold: true }),
                            ...(item.description
                              ? [new TextRun({ text: `\n${item.description}` })]
                              : []),
                          ],
                        }),
                      ],
                      shading: { fill: index % 2 === 0 ? "F7F7F7" : "FFFFFF" },
                    }),
                    new TableCell({
                      children: [new Paragraph(String(item.qty))],
                      shading: { fill: index % 2 === 0 ? "F7F7F7" : "FFFFFF" },
                    }),
                    new TableCell({
                      children: [new Paragraph(`$${Number(item.price).toFixed(2)}`)],
                      shading: { fill: index % 2 === 0 ? "F7F7F7" : "FFFFFF" },
                    }),
                    new TableCell({
                      children: [new Paragraph(`$${Number(item.qty * item.price).toFixed(2)}`)],
                      shading: { fill: index % 2 === 0 ? "F7F7F7" : "FFFFFF" },
                    }),
                  ],
                })
              ),
            ],
          }),

          blankLine(),
          blankLine(),

          // ---------------------------
          // TOTALS
          // ---------------------------
          new Paragraph({
            children: [
              new TextRun({ text: `Subtotal: $${subtotal.toFixed(2)}`, break: 1 }),
              new TextRun({ text: `HST (13%): $${hst.toFixed(2)}`, break: 1 }),
              new TextRun({
                text: `TOTAL: $${total.toFixed(2)}`,
                bold: true,
                color: "D4AF37",
                break: 1,
              }),
            ],
            alignment: AlignmentType.RIGHT,
            spacing: { after: 300 },
          }),

          // ---------------------------
          // FOOTER
          // ---------------------------
          new Paragraph({
            children: [
              new TextRun({
                text: company.footer || `Thank you for choosing ${company.name} Solutions`,
              }),
            ],
            alignment: AlignmentType.CENTER,
            color: "000000",
          }),
        ],
      },
    ],
  });

  const buffer = await Packer.toBlob(doc);
  saveAs(buffer, `Quote_${project.prj_code}_${(new Date()).toISOString().split('T')[0]}_${(new Date()).getSeconds()}.docx`);
}
